/**
 * 需要动态加载进header标签的tab的css样式
 * @remarks
 * 防止拖拽时页签样式失效
 * 由于“拖拽中”的元素是由第三方插件动态生成并附加到body上的，本组件的css样式无法被应用
 * 所以在组件初始化的过程中直接在head标签上创建一个style标签，用于包含tab页签的相关样式
 * （顺便隐藏掉“monaco-aria-container”元素，该元素由monaco-editor生成）
 */
export const GLOBAL_TAB_CSS = `
.tab-item.from-ide-code-view {
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.tab-item.from-ide-code-view .tab-item-content.drag-tab-moving--from-code-view {
  display: flex;
  align-items: center;
  height: 40px;
  overflow: hidden;
  background-color: #E8E9E9;
  border-radius: 5px;
  border: 1px solid #8e959b;
}
.tab-item.from-ide-code-view .tab-item-content.drag-tab-moving--from-code-view .tab-item-close {
  margin-right: 5px;
  color: #878787;
}
.tab-item.from-ide-code-view .tab-item-content.drag-tab-moving--from-code-view .tab-item-icon {
  padding-left: 0px;
}
.tab-item.from-ide-code-view .tab-item-content.drag-tab-moving--from-code-view .tab-item-text {
  display: block;
  padding: 0px 6px 2px 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.monaco-aria-container {
  display: none !important;
}
`;
